import { useNavigate } from "react-router-dom";
import demoData from "lib/demoData";
import { PAGE_STORAGE_KEY } from "lib/theme";

export default function Demos() {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-[1100px] h-[100%]">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-0 mb-[20px] sm:mb-[30px]">
        <div className="text-2xl font-bold text-[var(--dash-text-strong)] flex items-center gap-2.5">
          <i className="fas fa-video text-[var(--theme-accent)]"></i> Demos
        </div>
        <button
          type="button"
          onClick={() => {
            localStorage.setItem(PAGE_STORAGE_KEY, "front");
            navigate("/");
          }}
          className="text-sm px-[15px] py-2 border border-[var(--dash-border)] rounded-md text-[var(--dash-text)] hover:border-[var(--dash-text-strong)] hover:text-[var(--dash-text-strong)] transition-all flex items-center gap-2 cursor-pointer self-start sm:self-auto"
        >
          <i className="fas fa-arrow-left"></i> Back to Dashboard
        </button>
      </div>

      {demoData.map((ele, index) => {
        return (
          <div key={`demo-section-${index}`}>
            <div className="flex items-center justify-between border-b border-[var(--dash-border)] pb-3 mb-6">
              <h3 className="flex items-center gap-2.5 text-lg font-semibold text-[var(--dash-text-strong)] sm:text-xl md:text-2xl">
                <img src={ele.img} alt={ele.id} width={28} height={28} className="shrink-0" />{" "}
                {ele.id}
              </h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-20 mb-12">
              {ele.demos.map((demo, demoIndex) => (
                <div
                  key={`demo-${demoIndex}-${demo.title}`}
                  className="bg-[var(--dash-surface)] border border-[var(--dash-border)] p-2 rounded-xl text-center transition-all hover:border-[var(--theme-accent)] hover:-translate-y-1 w-auto h-auto"
                >
                  <p className="mb-2 px-1 text-base font-semibold leading-snug text-[var(--dash-text-strong)] sm:text-lg md:text-xl md:leading-snug">
                    {demo.title}
                  </p>
                  <iframe
                    className="w-full h-[240px] rounded-xl"
                    src={demo.url}
                    title={demo.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
